export default "__VITE_ASSET__Dlx_gzmE__"